<template>
  <div>
    <div class="evaluation-container">
      <div v-for="criterion in group.items" :key="criterion.key" class="criterion-block">
        <el-tag v-if="criterion.label" type="danger" class="criterion-tag">
          {{ criterion.label }}
        </el-tag>
        <div class="criterion-score-row">
          <div class="criterion-score-selector">
            <span class="label-score">Điểm tiêu chí: </span>
            <el-select
                :disabled="readonly"
                clearable
                class="score-select"
                v-model="criterion.criterion_score"
                placeholder="Chọn điểm"
                @change="() => handleScoreChange(criterion)"
            >
              <el-option
                  v-for="option in criterion.items"
                  :key="option.score"
                  :label="option.score"
                  :value="option.score"
              />
            </el-select>
          </div>
          <el-button
              :disabled="readonly"
              class="bg-header-color text-white"
              type="primary"
              @click="handleSelectBarem(criterion)"
          >
            Chấm theo barem
          </el-button>
        </div>
        <div class="criterion-comment">
          <span class="label-score">Nhận xét tự động: </span>
          <div
              class="auto-comment"
              v-if="getAutoComment(criterion)"
              style="white-space: pre-line"
             
          > 
            {{ getAutoComment(criterion) }} </div>
          <div v-else class="auto-comment placeholder">
            Tự động điền nhận xét ở đây
          </div>
        </div>
      </div>
      <div class="specific-comment">
        <span>Nhận xét cụ thể, dẫn chứng <span class="required">*</span></span>
        <el-input
            :disabled="readonly"
            type="textarea"
            :rows="5"
            v-model="group.comment_detail"
            placeholder="Viết nhận xét cụ thể tại đây"
        />
        <div v-if="!isAI && !isView" class="ai-hint">
          <span class="ai-hint-icon">✦</span>
          Nhận xét này được AI gợi ý, bạn có thể chỉnh sửa nếu cần
        </div>
      </div>
    </div>
    <div class="actions">
<!--      <el-button @click="handleBack" class="back-button">Quay lại</el-button>-->
      <el-button v-if=" isLastTab" @click="onSubmit" :disabled="disabled" type="primary" class="text-white">Tiếp theo</el-button>
    </div>

    <el-dialog :visible.sync="followBarem" width="60%" :before-close="handleClose">
      <template #title>
      <span class="dialog-title">
        Barem chấm điểm <span class="criterion-label">{{ criterionSelected?.label }}</span>
      </span>
      </template>
      <TableMarkBarem
          :criterion="criterionSelected"
          :selectedScore="criterionSelected?.criterion_score"
          @select-item="handleSelectItem"
      />
    </el-dialog>
  </div>
</template>

<script>
import TableMarkBarem from '../../marking-exam/components/TableMarkBarem.vue'

export default {
  name: 'MarkExamForm',
  components: {
    TableMarkBarem
  },
  props: {
    group: {
      type: Object,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
    isLastTab: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isAI: {
      type: Boolean,
      default: false
    },
    isView: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      followBarem: false,
      criterionSelected: null
    }
  },
  methods: {
    handleSelectBarem(item) {
      this.criterionSelected = item
      this.followBarem = true
    },
    handleSelectItem(selectedItem) {
      if (!this.criterionSelected) return
      this.criterionSelected.criterion_score = selectedItem.score
      this.criterionSelected.comment_auto = selectedItem.comment ?? ''
      this.criterionSelected.e_comment_auto = selectedItem.eComment ??selectedItem.comment?? ''
      this.followBarem = false
    },
    handleClose() {
      this.followBarem = false
    },
    getAutoComment(criterion) {
      
        const match = criterion.items?.find(
            (i) => i.score == criterion.criterion_score
        )
        return match?.eComment || criterion.e_comment_auto || match?.comment 
      }
      
    },
    handleScoreChange(criterion) {
      const match = criterion.items.find(
          (i) => i.score === criterion.criterion_score
      )
      criterion.comment_auto = match?.comment ?? ''
      criterion.e_comment_auto = match?.eComment ?? ''
    },
    validateAllCriteriaScored() {
      return this.group.items.every(
          (item) =>
              item.criterion_score !== undefined &&
              item.criterion_score !== null &&
              item.criterion_score !== ''
      )
    },
    validateCommentDetail() {
      return this.group.comment_detail && this.group.comment_detail.trim() !== ''
    },
    showValidationError(message) {
      this.$message.warning(message)
    },
    validateForm() {
      // if (!this.validateAllCriteriaScored()) {
      //   this.showValidationError('Vui lòng chọn điểm cho tất cả tiêu chí.')
      //   return false
      // }
      //
      // if (!this.validateCommentDetail()) {
      //   this.showValidationError('Vui lòng nhập nhận xét cụ thể trước khi tiếp tục.')
      //   return false
      // }
      //
      // return true
    },
    onSubmit() {
      // if (!this.readonly && !this.validateForm()) {
      //   return
      // }
      this.$emit('go-next', this.group.key)
    },

    handleBack() {
      this.$emit('go-back', this.group.key)
    }
  }

</script>

<style scoped>
.evaluation-container {
  background-color: #F8F8F8;
  padding: 16px;
  max-height: 450px;
  overflow-y: auto;
}

.criterion-block {
  margin-bottom: 24px;
}

.criterion-tag {
  margin-bottom: 8px;
  background-color: #FF9393;
  color: black;
}

.criterion-score-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin: 8px 0;
}

.criterion-score-selector {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
}

.label-score {
  text-align: start;
  color: #4F4F4F;
}

.score-select {
  width: 150px;
}

.criterion-comment {
  margin-top: 8px;
}

.auto-comment {
  width: 100%;
  max-height: 150px;
  border: 1px solid #5F5F5F;
  border-radius: 6px;
  background-color: white;
  padding: 8px;
  margin-top: 8px;
  overflow-y: auto;
}

.auto-comment.placeholder {
  height: 60px;
  color: lightgray;
}

.specific-comment {
  margin-top: 16px;
}

.required {
  color: red;
}

.actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
  gap: 8px;
}

.back-button {
  background-color: #646464;
  color: white;
}

.dialog-title {
  font-weight: 600;
  font-size: 18px;
}

.criterion-label {
  text-transform: lowercase;
}

.ai-hint {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 8px;
  font-size: 13px;
  color: #8c8c8c;
}

.ai-hint-icon {
  color: #b37feb;
  font-size: 14px;
}
</style>
